const _excluded = ["className", "children"],
  _excluded2 = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import cn from 'classnames';
import { Card, Typography } from 'seagull';
import styles from "./CommonComponents.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SuccessIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M11.7305 7.23047L7.79303 11.168L5.82428 9.19922",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9 0.65C13.6116 0.65 17.35 4.38842 17.35 9C17.35 13.6116 13.6116 17.35 9 17.35C4.38842 17.35 0.65 13.6116 0.65 9C0.65 4.38842 4.38842 0.65 9 0.65Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10"
  })]
});
export const SuccessBox = props => {
  const {
      className,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(className, styles.sucessBox),
    children: [/*#__PURE__*/_jsx(SuccessIcon, {}), /*#__PURE__*/_jsx(Typography, {
      style: {
        marginInlineStart: '8px'
      },
      children: children
    })]
  }));
};
export const ErrorBox = props => {
  const {
      className,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(className, styles.errorBox),
    children: children
  }));
};
export const ImportCard = props => {
  const {
    children,
    title,
    subtitle,
    actionsStart,
    actionsEnd
  } = props;
  return /*#__PURE__*/_jsxs(Card, {
    padding: "m",
    className: styles.cardRoot,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [title && /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "normal",
        children: title
      }), subtitle && /*#__PURE__*/_jsx(Typography, {
        children: subtitle
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: children
    }), (actionsStart || actionsEnd) && /*#__PURE__*/_jsxs("div", {
      className: styles.cardActions,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.cardActionBlock,
        children: actionsStart
      }), /*#__PURE__*/_jsx("div", {
        className: styles.cardActionBlock,
        children: actionsEnd
      })]
    })]
  });
};